<template>
  <!-- add html here -->
  <ul class="card-list" ref="cards">
    <li class="card">
      <h2>{{cardNumber(cards)}} cards</h2>
      
    </li>
    
  	<card
        v-for="card in filteredCards"
        :card="card" :user="user" :key="card.key"
        >
      </card>
   </ul>
</template>
<script>
// add js here
import Card from './Card'
import cardRepository from '../../data/CardRepository'
import EventBus from '../../components/EventBus'

export default {
  props: ['user'],
	components: {
		Card
	},
	data() {
		return {
			cards: [],
			searchQuery: '',
      loadCard: true
		}
	},
	computed: {
      filteredCards () {
        return this.cards.filter((card) => {
          if (this.searchQuery) return (card.title.indexOf(this.searchQuery) !== -1 || card.description.indexOf(this.searchQuery) !== -1) // returns truthy if query is found in title or content
          return true
        })
    	}
    },
    created: function () {
      	EventBus.$on('search', this.passQuery)
    },
    methods: {
    	passQuery: function(query){
    		this.searchQuery = query;
    	},
      cardNumber: function(cards){
        return Object.keys(cards).length;
      },
    },
    created(){

    },
	mounted () {
		cardRepository.on('added', (card) => {
      		this.cards.unshift(card) // add the card to the beginning of the array
          if(this.loadCard) {
            EventBus.$emit('loaded')
            this.loadCard = false
          }
      	})
      	cardRepository.on('changed', ({key, title, description, url, stacks, length}) => {
      	    let outdatedCard = cardRepository.find(this.cards, key) // get specific note from the notes in our VM by key
      	    outdatedCard.title = title
      	    outdatedCard.description = description
      	    outdatedCard.url = url
      	    outdatedCard.stacks = stacks
            outdatedCard.length = length
      	})
      	cardRepository.on('removed', ({key}) => {
      	    let cardToRemove = cardRepository.findIndex(this.cards, key) // get specific note from the notes in our VM by key
      	    this.cards.splice(cardToRemove, 1) // remove note from notes array
      	})
      	cardRepository.attachFirebaseListeners()
	},
  beforeDestroy() {
    cardRepository.removeAllListeners()
    cardRepository.detachFirebaseListeners()
  }
}
</script>


// WEBPACK FOOTER //
// Index.vue?1d6d6266